( function () {
	'use strict';

	function mathOperatorService () {
		var list = {};

		// start - internal utility functions
		function maplist ( mapper ) {
			return Object.keys( list ).map( mapper );
		}

		function filterMapper ( key ) {
			return list[ key ].filter;
		}

		function displayMapper ( key ) {
			return list[ key ].data;
		}

		// add an array to an object or appends data when the array already exists
		function addAppendOperatorToGroup ( group, groupKey, groupData ) {
			if ( groupKey in group ) {
				group[ groupKey ].push( groupData );
			} else {
				group[ groupKey ] = [ groupData ];
			}
		}
		// end

		function reset () {
			list = {};
		}

		function register ( key, data ) {
			list[ key ] = {
				'oprGroup' : data.operatorGroup,

				'filter' : {
					'pattern' : data.filterPattern,
					'replace' : data.replacementPattern
				},

				'data' : {
					'key'     : data.operatorKey,
					'display' : data.buttonDisplay || data.operatorKey,
					'isOptr'  : true,
					'value'   : {
						'id' : data.operatorKey
					}
				}
			};
		}

		function getAll () {
			return list;
		}

		function getFilters () {
			return maplist( filterMapper );
		}

		function getDisplay () {
			return maplist( displayMapper );
		}

		// groups operators to be used when displaying buttons grouped together
		function getOperatorGroup () {
			var group = {};

			Object.keys( list ).map( function ( key ) {
				var optrData = list[ key ];

				addAppendOperatorToGroup( group, 'grp' + optrData.oprGroup, optrData.data );
			} );

			return group;
		}

		return {
			'getOperatorGroup' : getOperatorGroup,
			'getFilters'       : getFilters,
			'getDisplay'       : getDisplay,
			'register'         : register,
			'getAll'           : getAll,
			'reset'            : reset
		};
	}

	angular
		.module( 'app.components' )
		.factory( 'mathOperatorService', mathOperatorService );
} )( );
